 const scrollBtn = document.querySelector('.bosHeroStoryTellingButton');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function (e) {
      e.preventDefault();

      const currentSection = this.closest('.shopify-section');
      let nextSection = currentSection?.nextElementSibling;

      while (nextSection && !nextSection.classList.contains('shopify-section')) {
        nextSection = nextSection.nextElementSibling;
      }

      if (nextSection) {
        // nextSection.scrollIntoView({ behavior: 'smooth' });
        const y = nextSection.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
  const announcementBar = document.querySelector(".announcement-bar");
  const section = document.querySelector(".bos_section-wrapper");

  if (announcementBar && section) {
    const updateOffset = () => {
      const height = announcementBar.offsetHeight;
      section.style.marginTop = `${height}px`;
    };

    // Run on load
    updateOffset();

    // Update on resize (responsive changes)
    window.addEventListener("resize", updateOffset);
  }
});